// extracted by mini-css-extract-plugin
export default {"layout":"m+BCR-XeuxkotRJjqhvr0Q=="};